export class Ownership {
	constructor(
		public id: number,
		public name: string
	) {
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/models/ownership.ts